// Centralized API base URL resolution for fetch calls
// Priority: REACT_APP_API_BASE_URL -> dev default (127.0.0.1:5000) -> window.location.origin

const resolvedBase = (() => {
  const envBase = process.env.REACT_APP_API_BASE_URL;
  if (envBase && typeof envBase === 'string' && envBase.trim() !== '') {
    return envBase.trim();
  }
  if (process.env.NODE_ENV === 'development') {
    return 'http://127.0.0.1:5000';
  }
  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    return window.location.origin;
  }
  return '';
})();

export const apiUrl = (path) => {
  const base = resolvedBase.replace(/\/+$/, '');
  const p = String(path || '').startsWith('/') ? String(path) : `/${String(path || '')}`;
  return `${base}${p}`;
};

export const API_BASE_URL = resolvedBase;

// Stripe publishable key (test mode)
// Get from: https://dashboard.stripe.com/test/apikeys
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_YOUR_KEY_HERE';

